import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';
import { useGetStockStatusIdentifier } from './useGetStockStatusIdentifier.js';
import { useGetStockStatusLabel } from './useGetStockStatusLabel.js';

const StockIndicator = ({ status , quantity , additionalLabel  })=>{
    const identifier = useGetStockStatusIdentifier(status, quantity);
    const label = useGetStockStatusLabel(identifier, quantity);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('common-stock-indicator', `common-stock-indicator--${identifier}`),
        "data-t": "stock-indicator"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "common-stock-indicator__level"
    }), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption-head"
    }, label, "\xa0", additionalLabel && /*#__PURE__*/ React.createElement("span", {
        className: "common-stock-indicator__additional"
    }, additionalLabel)));
};

export { StockIndicator, StockIndicator as default };
//# sourceMappingURL=StockIndicator.js.map
